import { Injectable } from '@angular/core';

import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';

@Injectable()
export class UiConstant {
    public fixtureStyles = {
        mainContainer: {
            background: '#111111',
            'overflow-x': 'auto',
        },
        tableNoNBorder: {
            border: 'none',
        },
    };
    constructor() {}
}

export const INITIAL_SPORT_TYPE_ENUM = 1;
export const INITIAL_TOURNAMENT_TYPE = 0;
export const SLIP_WIDTH = 510;
export const TOUCH_NONE = { 'touch-action': 'none', 'user-select': 'none' };
export const LANGUAGES = ['en', 'tr', 'de', 'ru', 'pl', 'fr', 'es', 'el', 'bg', 'da', 'ro', 'it', 'pt', 'sq'];
export const DefaultLangCode = 'de';
export const DefaultLangId = 6;
